import {Component, OnInit} from '@angular/core';
import {PropertyFormComponent} from "./property-form/property-form.component";
import {PropertyService} from "../../shared/forms/services/property.service";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {FormModel} from "../../shared/forms/models/constants";
import {CommonModule} from "@angular/common";

interface Properties {
    id: number;
    dtype: string;
    dtypeLabel: string;
    languageWertMap: {};
}

@Component({
    selector: 'app-properties',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    templateUrl: './properties.component.html',
    styleUrl: './properties.component.scss'
})
export class PropertiesComponent implements OnInit {

    formValues!: FormModel[];
    ref!: DynamicDialogRef;
    properties: Properties[] = [];
    translatedProperties: Properties[] = [];
    selectedProperty: any;

    constructor(public dialogService: DialogService,
                public translate: TranslateService,
                private propertyService: PropertyService) {

    }


    ngOnInit(): void {
        console.log('PropertiesComponent geladen');
        this.getProperties();
    }

    getProperties() {
        this.propertyService.getProperties().subscribe((value: any[]) => {

            this.translatedProperties = value.map(property => {
                this.selectedProperty = property;
                return {
                    ...property,
                    dtypeLabel: this.translate.instant(`properties.${property.dtype}`)
                };
            });

            this.properties = value;
        });
    }


    showPropertyForm(formId: string, formLabel: string) {
        //debugger;

        this.ref = this.dialogService.open(PropertyFormComponent, {
            header: "",
            width: '70%',
            data: {
                propertyKey: formId,
                propertyLabel: formLabel,
            },

        });
        this.ref.onClose.subscribe(value => {
            if (value) {
                this.propertyService.getPropertyListByKey(formId+"").then(data => this.formValues = data);
            }
        });
    }
}
